
export enum MarketMakerCoverage {
    NONE = "NONE",
    BAD = "BAD",
    AVERAGE = "AVERAGE",
    GOOD = "GOOD",
    TOTAL = "TOTAL"
}

export const OrderedMarketMakerCoverage = [
    MarketMakerCoverage.TOTAL,
    MarketMakerCoverage.GOOD,
    MarketMakerCoverage.AVERAGE,
    MarketMakerCoverage.BAD,
    MarketMakerCoverage.NONE
];

export class MarketMakerCoverageUtil {

    public static isMarketCoverage(val: string): val is MarketMakerCoverage {
        return val in MarketMakerCoverage
    }

    public static compare(m1: MarketMakerCoverage, m2: MarketMakerCoverage) {
        return OrderedMarketMakerCoverage.indexOf(m1) - OrderedMarketMakerCoverage.indexOf(m2);
    }
}
